import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routeConfig } from '../shared/utilities/pages-config';
import { PaymentComponent } from './payment/payment.component';

const routes: Routes = [
  {
    path:  routeConfig.payment_status.name,
    component: PaymentComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { }
